module.exports = __webpack_public_path__ + "static/wunmi-07f4f2ccb48fef22beeba91c840f7761.webp";